import { Controller } from "stimulus";

export default class extends Controller {
  connect(){
    if (window?.Android && typeof window.Android.logout == "function") {
      Android.logout();
      return null;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "logout",
      });
    }
  }
}
